import getCookie from "lib/cookie/getCookie";

require('../../../../../node_modules/intl-tel-input/build/css/intlTelInput.css');
require('./style.scss');

import setCookie from 'lib/cookie/setCookie';
import {validatePhoneNumber, validateEmail, getIsoCode, getCountry, getCurrentCountry} from 'a_root-folder/lib/service/geo.service';
import intlTelInput from "intl-tel-input";
import phone from 'phone';
let intlTel = null;

const getSelectedIso = () => {
    return intlTel.getSelectedCountryData().iso2;
}

const formatCountryInput = (input, isoCode) => {
    return new Promise((res, rej) => {

        if(!isoCode){
            getCurrentCountry()
                .then((country_name) => {
                    const countryIsoCode = getIsoCode(country_name);

                    intlTel = intlTelInput(input, {initialCountry: countryIsoCode});

                    res({name: country_name, isoCode: countryIsoCode});
                })
                .catch((err) => {
                    rej(err);
                })
        }else{
            intlTel = intlTelInput(input, {initialCountry: isoCode});

            res({name: countryName, isoCode});
        }
    })
}

export default (translate, send) => {
    let countryName = null;
    let countryIsoCode = null;
    let errorColor = 'border-red';
    const sendPhone = (e, {phone, comments, checkbox, name, country, email, isoCode}) => {
        e.preventDefault();

        send({name, comments, checkbox, phone, country, email, isoCode});
    }

    const hideLeadGen = (state=true) => {
        setCookie('hideLeadGen', state);
    }

    const modalPhoneElement = () => document.body.querySelector('.modal-input-phone');
    const modalEmailElement = () => document.body.querySelector('.modal-input-email');
    const modalNameElement = () => document.body.querySelector('.modal-input-name');
    const modalCommentsElement = () => document.body.querySelector('.modal-input-comments');
    const modalCheckboxElement = () => document.body.querySelector('.modal-checkbox input');

    const onSubmit = (e) => {
        e.preventDefault();

        clearErroMsg();
        const phoneNumber = getPhone(e);
        const email = getEmail(e);
        const name = getName(e);
        const comments = getComments(e);
        const checkbox = getCheckbox(e);
        countryIsoCode = getSelectedIso();
        countryName = getCountry(countryIsoCode);

        if(checkbox) hideLeadGen();

        if(!validateEmail(email)) return  addErroMsg(`${translate('INVALID_EMAIL')}`, modalEmailElement());

        validatePhoneNumber(phoneNumber, countryIsoCode)
            .then(({phone}) => {
                sendPhone(e, {phone, comments, checkbox, name, country: countryName, email: getEmail(e), isoCode: countryIsoCode});
                hideLeadGen();
            })
            .catch(({err}) => {
                console.log(err)
                addErroMsg(`${translate('INVALID_PHONE_NUMBER')}`, modalPhoneElement());
            })
    }

    const clearErroMsg = () => {
        const errValidationPhoneContainer = document.body.querySelector('.err-validation-phone-container');
        const errValidationPhoneMsg = document.body.querySelector('.err-validation-phone-msg');

        errValidationPhoneContainer.classList.add('hidden');
        errValidationPhoneMsg.innerHTML = '';
    }

    const resetErrorColor = (msg, el) => {
        modalPhoneElement().classList.remove(errorColor);
        modalEmailElement().classList.remove(errorColor);
        modalNameElement().classList.remove(errorColor);
        modalCommentsElement().classList.remove(errorColor);
        modalCheckboxElement().classList.remove(errorColor);
    }

    const setErrorColor = (el) => {
        el.classList.add(errorColor);
    }

    const addErroMsg = (msg, el) => {
        resetErrorColor();
        setErrorColor(el);

        const errValidationPhoneContainer = document.body.querySelector('.err-validation-phone-container');
        const errValidationPhoneMsg = document.body.querySelector('.err-validation-phone-msg');

        errValidationPhoneContainer.classList.remove('hidden');
        errValidationPhoneMsg.innerHTML = msg;
    }

    const getPhone = () => {
        return modalPhoneElement().value;
    }

    const getEmail = () => {
        return modalEmailElement().value;
    }

    const getName = () => {
        return modalNameElement().value;
    }

    const getComments = () => {
        return modalCommentsElement().value;
    }

    const getCheckbox = () => {
        return modalCheckboxElement().checked;
    }

    const addErroBlock = (send) => {
        const errPhone = document.createElement('p');
        errPhone.classList.add('err-validation-phone-container');
        errPhone.classList.add('hidden');
        const errPhoneMsg = document.createElement('span');
        errPhoneMsg.classList.add('err-validation-phone-msg');
        errPhoneMsg.innerText = translate('INVALID_PHONE_NUMBER');
        errPhone.appendChild(errPhoneMsg);

        return errPhone;
    }

    const container = document.createElement('div');
    container.classList.add('modal-container');

    const body = document.createElement('div');
    body.classList.add('broken-webrtc');
    const span = document.createElement('span');
    span.classList.add('broken-webrtc-label');

    const form = document.createElement('form');
    const pText = document.createElement('p');
    // pText.innerText = translate('ENTER_NAME_AND_NUMBER');
    pText.innerText = translate('If you want to get in touch with the agent about this or similar properties, please enter your details below: ');

    const pInput = document.createElement('div');
    pInput.classList.add('modal-container');

    const containerName = document.createElement('div');
    containerName.classList.add('iti');
    containerName.classList.add('iiti--allow-dropdown');

    const inputName = document.createElement('input');
    inputName.type = 'text';
    inputName.placeholder = translate('Name');
    inputName.classList.add('modal-input');
    inputName.classList.add('modal-input-name');
    containerName.appendChild(inputName);

    const input = document.createElement('input');
    input.type = 'text';
    input.placeholder = translate('Phone number');
    input.classList.add('modal-input');
    input.classList.add('modal-input-phone');

    const containerEmail = document.createElement('div');
    containerEmail.classList.add('iti');
    containerEmail.classList.add('iiti--allow-dropdown');

    const email = document.createElement('input');
    email.type = 'text';
    email.placeholder = translate('Email');
    email.classList.add('modal-input');
    email.classList.add('modal-input-email');
    containerEmail.appendChild(email);

    const containerText = document.createElement('div');
    containerText.classList.add('iti');
    containerText.classList.add('iiti--allow-dropdown');

    const comments = document.createElement('textarea');
    comments.placeholder = translate('Comments');
    comments.classList.add('modal-input');
    comments.classList.add('modal-input-comments');
    containerText.appendChild(comments);

    const checkbox = document.createElement('div');
    checkbox.classList.add('iti');
    checkbox.classList.add('iti--allow-dropdown');
    checkbox.classList.add('modal-checkbox');
    checkbox.classList.add('checkbox');
    const checkboxLabel = document.createElement('label');
    checkboxLabel.classList.add('label');
    checkboxLabel.innerHTML = translate('Do not show again');
    const checkboxInput = document.createElement('input');
    checkboxInput.type= 'checkbox';
    checkbox.appendChild(checkboxLabel);
    checkbox.appendChild(checkboxInput);
    checkbox.onclick = () => {
        const state = getCheckbox()

        hideLeadGen(state);
    }

    pInput.appendChild(containerName);
    pInput.appendChild(containerEmail);
    pInput.appendChild(input);
    pInput.appendChild(checkbox);
    pInput.appendChild(containerText);

    const submit = document.createElement('button');
    submit.classList.add('check-password-submit');
    submit.classList.add('button');
    submit.type = 'submit';
    submit.value = translate('CALL_ME_BACK');
    submit.innerHTML = translate('CALL_ME_BACK');
    form.onsubmit = onSubmit;
    pInput.appendChild(submit);

    form.appendChild(pText);
    form.appendChild(pInput);
    form.appendChild(addErroBlock(sendPhone));

    body.appendChild(span);
    body.appendChild(form);
    container.appendChild(body);

    formatCountryInput(input)
        .then(({name, isoCode}) => {
            countryName = name;
            countryIsoCode = isoCode;
        })

    return container;
}
